"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_1 = require("@mdi/js");
var react_1 = require("@mdi/react");
var auth_1 = require("firebase/auth");
var react_2 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var auth_2 = require("react-firebase-hooks/auth");
var react_router_1 = require("react-router");
var __1 = require("../../");
var Login = function (props) {
    var _a = (0, __1.useEloise)(), theme = _a.theme, logic = _a.logic, siteConfig = _a.siteConfig;
    var _b = (0, react_2.useState)(), email = _b[0], setEmail = _b[1];
    var _c = (0, react_2.useState)(), password = _c[0], setPassword = _c[1];
    var _d = (0, react_2.useState)(null), loginError = _d[0], setLoginError = _d[1]; // State to store login error message
    var _e = (0, auth_2.useAuthState)(logic.fb.auth), user = _e[0], loading = _e[1], error = _e[2];
    var login = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
        var test_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, auth_1.signInWithEmailAndPassword)(logic.fb.auth, email, password)];
                case 1:
                    test_1 = _a.sent();
                    console.log(test_1);
                    setLoginError(null); // Clear login error message on successful login
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setLoginError(error_1.message); // Set login error message on failed login
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Configure the Google sign-in provider
    var provider = new auth_1.GoogleAuthProvider();
    var navigate = (0, react_router_1.useNavigate)();
    // Handle Google sign-in
    var signInWithGoogle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, user_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, auth_1.signInWithPopup)(logic.fb.auth, provider)];
                case 1:
                    result = _a.sent();
                    user_1 = result.user;
                    console.log(user_1);
                    setLoginError(null); // Clear login error message on successful login
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    setLoginError(error_2.message); // Set login error message on failed login
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_2.default.createElement(react_bootstrap_1.Container, { style: {
            position: "relative",
            paddingTop: "90px",
            maxHeight: "60vh",
            overflowY: "scroll",
        } },
        react_2.default.createElement(__1.Heading, { color: 0, size: 4, style: {
                fontStyle: "italic",
                position: "absolute",
                top: "20px",
                left: "20px",
            } }, "Login"),
        react_2.default.createElement("img", { src: siteConfig.logo, width: "50px", style: { position: "absolute", top: "20px", right: "20px" }, className: "d-inline-block align-top", alt: "React Bootstrap logo" }),
        react_2.default.createElement(react_bootstrap_1.Row, { className: "" },
            react_2.default.createElement(react_bootstrap_1.Col, { lg: 7, className: "mx-auto text-center", style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                react_2.default.createElement(react_1.Icon, { color: theme.colors[0], size: "8vw", path: js_1.mdiAccountCircleOutline }))),
        user ? (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-1" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" },
                    react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-2" },
                        react_2.default.createElement(__1.Heading, { size: 3 }, "Logged in as ".concat(logic.fb.auth.currentUser.email))),
                    react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-1" },
                        react_2.default.createElement(__1.Button, { rounded: true, onClick: function () { return navigate("/account"); } }, "Manage Account")),
                    react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-1" },
                        react_2.default.createElement(__1.Button, { rounded: true, onClick: function () { return (0, auth_1.signOut)(logic.fb.auth); } }, "Log Out")))))) : (react_2.default.createElement(react_2.default.Fragment, null, loading ? (react_2.default.createElement(__1.Loading, null)) : (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-5" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" },
                    react_2.default.createElement(__1.Input, { extLabel: true, state: email, setState: setEmail, label: "Email" }))),
            react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-2" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" },
                    react_2.default.createElement(__1.Input, { extLabel: true, state: password, type: "password", setState: setPassword, label: "Password" }))),
            react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-2" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" }, email && password && (react_2.default.createElement(__1.Button, { rounded: true, onClick: function () { return login(email, password); } }, "Login")))),
            react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-2" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" },
                    react_2.default.createElement(__1.Button, { rounded: true, onClick: signInWithGoogle }, "Sign in with Google"))),
            loginError && (react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-2" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 9, className: "mx-auto text-center" },
                    react_2.default.createElement("div", { style: { color: "red" } }, loginError))))))))));
};
exports.default = Login;
